<template>
    <div>
        <contact-header 
            :actIndex="actIndex" 
            :imgList="imgList" 
            :topStyle="topStyle"
            :logo="logo">
        </contact-header>
        <contact-way :wayInfo="contactInfo"></contact-way>
        <contact-need></contact-need>
        <contact-footer :bottom="bottom" :bottomInfo="contactInfo"></contact-footer>
    </div>
</template>

<script>
import ContactHeader from '@/components/mobile/Header'
import ContactWay from '@/components/mobile/ContactWay'
import ContactNeed from '@/components/mobile/ContactNeed'
import ContactFooter from '@/components/mobile/Footer'
export default {
    name: 'Contact',
    data () {
        return {
            actIndex: 6,
            topStyle: "",
            imgList: [],
            bottom: {},
            logo: '',
            contactInfo: {},
        }
    },
    components: {
        ContactHeader,
        ContactWay,
        ContactNeed,
        ContactFooter
    },
    mounted () {
        this.Pc_Mobile()
        this.getPageData()
    },
    methods: {
        _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
        },
        Pc_Mobile () {
            if(this._isMobile()) {
                this.$router.replace('/m_contact');
            }else{
                this.$router.replace('/contact');
            }
        },
        getPageData () {
            this.$http.post('home/index/m_contact',null, (res) => { 
                // console.log(res.data)
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.topStyle = "background:url('"+this.$imgUrl+res.data.header[0].m_lxwm.replace(/\\/g,'/')+"')"
                this.contactInfo = res.data.contact[0]
                this.$nextTick(()=>{
                })
            })
        },
    }
}
</script>

<style>
    
</style>


// WEBPACK FOOTER //
// src/views/mobile/Contact.vue